import { AppState } from '../AppStateProvider/interfaces';

export const complete = (state: AppState) =>
	(
		state.preview &&
		state.brand !== null &&
		state.url !== null &&
		state.device !== null
	) || (
		state.brand !== null &&
		((state.market !== null && state.kvps !== null) || state.url !== null) &&
		// state.password !== null &&
		state.device !== null
	);
